if (!customElements.get('card-size-atc')) {
  class CardSizeAtc extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.product__item-js');
      this.select = this.querySelector('[data-card-size-select]');
      this.selectWrap = this.querySelector('.product-card-size-atc__select-wrap');
      this.hiddenIdInput = this.querySelector('input[type="hidden"][name="id"]');
      this.button =
        this.querySelector('[data-card-size-atc-submit]') ||
        this.card?.querySelector('[data-card-size-atc-submit]');
      this.label =
        this.querySelector('[data-card-size-atc-label]') ||
        this.card?.querySelector('[data-card-size-atc-label]');
      // Cache labels before the button may move outside this element.
      this.soldOutLabel =
        this.button?.querySelector('.sold-out-message')?.textContent?.trim() || 'Sold Out';
      this.addToCartLabel =
        this.button?.getAttribute('aria-label') ||
        this.label?.textContent?.trim() ||
        'Add to cart';
      this.productTitle = this.dataset.productTitle || '';
      this.currentSize = this.dataset.initialSize || '';
      this.initialPack = this.dataset.initialPack || '';
      this.currentPack = this.initialPack;
      this.hideSizePills = this.dataset.hideSizePills === 'true';
      this.sizePosition = Number(this.dataset.sizePosition || 0);
      this.packPosition = Number(this.dataset.packPosition || 0);
      this.isSizeOption = this.dataset.isSizeOption === 'true';
      this.hasNamedOptions = this.dataset.hasNamedOptions === 'true';

      try {
        this.variants = JSON.parse(this.dataset.variants || '[]');
      } catch (error) {
        this.variants = [];
      }

      this.onSelectChange = this.onSelectChange.bind(this);
      this.onPillChange = this.onPillChange.bind(this);

      if (this.select) {
        this.select.addEventListener('change', this.onSelectChange);
      }

      if (this.card && !this.hideSizePills) {
        this.card.addEventListener('change', this.onPillChange, true);
      }

      this.placeButton();
      this.applySize(this.currentSize, { keepSelectedId: true });
    }

    placeButton() {
      if (!this.classList.contains('product-card-size-atc--beside-price')) return;
      if (!this.card || !this.button) return;

      if (this.card.classList.contains('size-atc-btn-below-stars')) {
        this.moveButtonToSlot(this.getBelowStarsSlot());
        return;
      }

      if (this.card.classList.contains('size-atc-btn-on-media')) {
        this.moveButtonToSlot(this.getMediaSlot());
      }
      // below_content: button stays in the form under price + dropdown
    }

    getBelowStarsSlot() {
      return (
        this.card.querySelector('[data-card-atc-below-stars]') ||
        this.card.querySelector('.product-card__atc-below-stars')
      );
    }

    getMediaSlot() {
      const media = this.card.querySelector('.product__inner');
      if (!media) return null;
      return (
        media.querySelector('[data-card-media-atc]') ||
        media.querySelector('.product-card__media-atc')
      );
    }

    moveButtonToSlot(slot) {
      if (!slot) return;

      const form = this.querySelector('form');
      const productForm = this.querySelector('product-form');
      if (form?.id) {
        this.button.setAttribute('form', form.id);
      }
      this.button.classList.add('swiper-no-swiping');

      if (this.button.parentElement !== slot) {
        slot.appendChild(this.button);
      }

      if (productForm) {
        productForm.submitButton = this.button;
      }

      this.bindMovedButtonClick();
    }

    bindMovedButtonClick() {
      if (this._movedButtonBound || !this.button) return;
      this._movedButtonBound = true;

      // Keep clicks from reaching the product link / carousel swipe.
      // Native submit via form="…" handles add-to-cart.
      this.button.addEventListener('click', (event) => {
        event.stopPropagation();
        const productForm = this.querySelector('product-form');
        if (productForm) productForm.submitButton = this.button;
      });
    }

    disconnectedCallback() {
      if (this.select) {
        this.select.removeEventListener('change', this.onSelectChange);
      }
      if (this.card) {
        this.card.removeEventListener('change', this.onPillChange, true);
      }
    }

    onPillChange(event) {
      const radio = event.target;
      if (!radio || radio.type !== 'radio') return;
      if (!radio.closest('.product-card-swatch-js')) return;
      if (!this.card || !this.card.contains(radio)) return;

      // Stop theme card-reload so this card updates locally (packs/title/price).
      event.stopImmediatePropagation();

      const label = radio.getAttribute('data-option-value') || '';
      this.card.querySelectorAll('.product-card-swatch-js li.variant-input').forEach((li) => {
        li.classList.remove('active');
      });
      radio.closest('li.variant-input')?.classList.add('active');

      // Flavour/Color-only (no Pack): keep full dropdown, sync selection by label.
      // Size + Pack: filter packs for the selected size.
      if (!this.packPosition) {
        this.selectVariantByLabel(label);
        return;
      }

      this.applySize(label);
    }

    onSelectChange() {
      this.syncFromSelectedOption();
    }

    optionLabel(variant) {
      const size = (variant.size || '').trim();
      const pack = (variant.pack || '').trim();
      // Size + Pack cards: pills pick size, dropdown shows pack only ("Pack of 4").
      // Flavour/Color-only cards (no pack option): keep showing the option label.
      if (this.packPosition && pack) return pack;
      if (size) return size;
      return variant.title || '';
    }

    findVariantByLabel(label) {
      const want = (label || '').toLowerCase().trim();
      if (!want) return null;
      return (
        this.variants.find((variant) => {
          const title = (variant.title || '').toLowerCase().trim();
          const size = (variant.size || '').toLowerCase().trim();
          const pack = (variant.pack || '').toLowerCase().trim();
          return (
            title === want ||
            size === want ||
            pack === want ||
            title.startsWith(`${want} /`) ||
            title.endsWith(`/ ${want}`)
          );
        }) || null
      );
    }

    selectVariantByLabel(label) {
      const list = this.variants.slice();
      const match = this.findVariantByLabel(label) || this.pickPreferredVariant(list);
      this.renderOptions(list, match);
      if (match) {
        this.currentPack = match.pack || this.currentPack;
        this.currentSize = match.size || this.currentSize;
        if (this.select) this.select.value = String(match.id);
        this.updateCard(match);
      }
    }

    variantsForSize(sizeLabel) {
      // No Size mapped, or no Pack option (Flavour-only, Size-only, etc.):
      // list every variant in the dropdown.
      if (!this.sizePosition || !this.packPosition) {
        return this.variants.slice();
      }
      const size = (sizeLabel || '').toLowerCase().trim();
      if (!size) return this.variants.slice();
      return this.variants.filter((variant) => (variant.size || '').toLowerCase().trim() === size);
    }

    pickPreferredVariant(list, preferredId) {
      if (!list.length) return null;
      if (preferredId) {
        const match = list.find((variant) => String(variant.id) === String(preferredId));
        if (match) return match;
      }
      // Prefer the currently/initially chosen pack when present in this list.
      const wantPack = (this.currentPack || this.initialPack || '').toLowerCase().trim();
      if (wantPack) {
        const packMatch = list.find((variant) => (variant.pack || '').toLowerCase().trim() === wantPack);
        if (packMatch) return packMatch;
      }
      // Fallback: first variant in the product's own order (top of admin list).
      return list[0];
    }

    applySize(sizeLabel, options = {}) {
      this.currentSize = sizeLabel || this.currentSize || '';
      const list = this.variantsForSize(this.currentSize);
      let preferredId = options.keepSelectedId
        ? this.select?.value || this.dataset.initialVariantId
        : null;

      // Flavour / non-Pack options: prefer the pill label match in the full list.
      if (!this.packPosition && sizeLabel) {
        const match = this.findVariantByLabel(sizeLabel);
        if (match) preferredId = match.id;
      }

      const selected = this.pickPreferredVariant(list, preferredId);
      this.renderOptions(list, selected);
      if (selected) {
        this.currentPack = selected.pack || this.currentPack;
        this.currentSize = selected.size || this.currentSize;
        if (this.select) this.select.value = String(selected.id);
        this.updateCard(selected);
      }
    }

    ensureHiddenIdInput() {
      if (this.hiddenIdInput) return this.hiddenIdInput;
      const form = this.querySelector('form');
      if (!form) return null;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'id';
      form.prepend(input);
      this.hiddenIdInput = input;
      return input;
    }

    setSelectVisible(visible) {
      if (this.selectWrap) {
        this.selectWrap.classList.toggle('is-slot-hidden', !visible);
        this.selectWrap.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }
      if (this.select) {
        this.select.disabled = !visible;
        if (visible) {
          this.select.setAttribute('name', 'id');
          if (this.hiddenIdInput) {
            this.hiddenIdInput.removeAttribute('name');
          }
        } else {
          this.select.removeAttribute('name');
          const hidden = this.ensureHiddenIdInput();
          if (hidden) hidden.setAttribute('name', 'id');
        }
      }
    }

    renderOptions(list, selected) {
      if (!this.select) {
        if (selected) {
          const hidden = this.ensureHiddenIdInput();
          if (hidden) hidden.value = String(selected.id);
        }
        return;
      }

      this.select.innerHTML = '';

      // Size / Flavor / Color: always show when there is at least one option.
      // Other options (Type, etc.): only when more than one choice.
      const canShow =
        list.length > 0 &&
        this.hasNamedOptions &&
        (this.isSizeOption || list.length > 1);

      if (!canShow) {
        this.setSelectVisible(false);
        if (selected) {
          const hidden = this.ensureHiddenIdInput();
          if (hidden) hidden.value = String(selected.id);
        }
        return;
      }

      this.setSelectVisible(true);
      list.forEach((variant) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = this.optionLabel(variant);
        option.dataset.available = variant.available ? 'true' : 'false';
        option.dataset.price = String(variant.price || 0);
        option.dataset.compare = String(variant.compare || 0);
        option.dataset.priceText = variant.price_text || '';
        option.dataset.compareText = variant.compare_text || '';
        option.dataset.image = variant.image || '';
        option.dataset.size = variant.size || '';
        option.dataset.pack = variant.pack || '';
        if (selected && String(selected.id) === String(variant.id)) {
          option.selected = true;
        }
        this.select.appendChild(option);
      });
    }

    syncFromSelectedOption() {
      const option = this.select?.selectedOptions?.[0];
      if (!option) return;
      const variant = this.variants.find((item) => String(item.id) === String(option.value));
      if (variant) {
        this.currentSize = variant.size || this.currentSize;
        this.currentPack = variant.pack || this.currentPack;
        this.updateCard(variant);
      } else {
        this.updateButton(option.dataset.available === 'true');
      }
    }

    updateCard(variant) {
      if (!this.card || !variant) return;

      this.updateButton(!!variant.available);
      this.updateTitle(variant.size);
      this.updatePrice(variant);
      this.updateImage(variant);
      this.updateLinks(variant.id);
      this.updateSortPrice(variant.price);
    }

    updateButton(available) {
      if (!this.button) return;
      this.button.disabled = !available;
      if (!this.label) return;
      this.label.textContent = available ? this.addToCartLabel : this.soldOutLabel;
    }

    updateTitle(sizeLabel) {
      const titleEl = this.card.querySelector('.product__name');
      if (!titleEl || !this.productTitle) return;
      // Append Size / Flavor / Color to the title (e.g. "Treatoy - Original").
      // Do not append other option types like "Hip & Joint".
      const size = this.isSizeOption ? (sizeLabel || this.currentSize || '').trim() : '';
      const nextTitle = size ? `${this.productTitle} - ${size}` : this.productTitle;
      titleEl.textContent = nextTitle;
      titleEl.setAttribute('aria-label', nextTitle);
      window.dispatchEvent(new CustomEvent('card-row-align'));
    }

    updatePrice(variant) {
      const priceRoot = this.card.querySelector('.product__price');
      if (!priceRoot) return;

      const priceText = variant.price_text || '';
      const compareText = variant.compare_text || '';
      const onSale = variant.compare > variant.price && compareText;

      if (onSale) {
        priceRoot.innerHTML = `
          <div class="card-product-price relative flex align-center wrap gap row-gap-0" style="--gap: 2px;--gap-desktop: 4px;">
            <div class="heading-color price-regular inline-block" dir="auto">
              <span class="price special-price heading-color sale-color">${priceText}</span>
            </div>
            <div class="price-regular grey-color inline-block" dir="auto">
              <s class="price-item compare-price body_weight">${compareText}</s>
            </div>
          </div>`;
      } else {
        priceRoot.innerHTML = `
          <div class="card-product-price relative flex align-center wrap gap row-gap-0" style="--gap: 2px;--gap-desktop: 4px;">
            <div class="heading-color price-regular inline-block" dir="auto">
              <span class="price">${priceText}</span>
            </div>
          </div>`;
      }
    }

    updateImage(variant) {
      if (!variant.image) return;
      const img = this.card.querySelector('.product-image .featured-image, .product__media .featured-image');
      if (!img) return;
      img.setAttribute('src', variant.image);
      if (img.hasAttribute('srcset')) {
        img.removeAttribute('srcset');
      }
    }

    updateLinks(variantId) {
      if (!variantId) return;
      this.card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        try {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('variant', String(variantId));
          link.href = `${url.pathname}${url.search}${url.hash}`;
        } catch (error) {
          // ignore invalid urls
        }
      });
    }

    updateSortPrice(price) {
      if (price == null) return;
      this.card.setAttribute('data-sort-price', String(price));
    }
  }

  customElements.define('card-size-atc', CardSizeAtc);
}
